// core/action/openingBalanceActions.js
import { openingBalanceAPI } from './api';
import { toast } from 'react-toastify';

export const openingBalanceActions = {
    // Save bank opening balance
    saveBankOpening: async (data) => {
        try {
            const response = await openingBalanceAPI.saveBank(data);
            if (response.success) {
                toast.success(response.message);
                return response;
            }
            return {
                success: false,
                message: response.message || 'Failed to save opening balance'
            };
        } catch (error) {
            console.error('Error saving bank opening:', error);
            toast.error(error.message || 'Failed to save opening balance');
            return {
                success: false,
                message: error.message || 'Failed to save opening balance'
            };
        }
    },

    // Save customer opening balance
    saveCustomerOpening: async (data) => {
        try {
            const response = await openingBalanceAPI.saveCustomer(data);
            if (response.success) {
                toast.success(response.message);
                return response;
            }
            return {
                success: false,
                message: response.message || 'Failed to save opening balance'
            };
        } catch (error) {
            console.error('Error saving customer opening:', error);
            toast.error(error.message || 'Failed to save opening balance');
            return {
                success: false,
                message: error.message || 'Failed to save opening balance'
            };
        }
    },

    // Save supplier opening balance
    saveSupplierOpening: async (data) => {
        try {
            const response = await openingBalanceAPI.saveSupplier(data);
            if (response.success) {
                toast.success(response.message);
                return response;
            }
            return {
                success: false,
                message: response.message || 'Failed to save opening balance'
            };
        } catch (error) {
            console.error('Error saving supplier opening:', error);
            toast.error(error.message || 'Failed to save opening balance');
            return {
                success: false,
                message: error.message || 'Failed to save opening balance'
            };
        }
    },

    // Save product opening stock
    saveProductOpening: async (data) => {
        try {
            const response = await openingBalanceAPI.saveProduct(data);
            if (response.success) {
                toast.success(response.message);
                return response;
            }
            return {
                success: false,
                message: response.message || 'Failed to save opening stock'
            };
        } catch (error) {
            console.error('Error saving product opening:', error);
            toast.error(error.message || 'Failed to save opening stock');
            return {
                success: false,
                message: error.message || 'Failed to save opening stock'
            };
        }
    },

    // Get opening balance summary
    getSummary: async (financialYear) => {
        try {
            const response = await openingBalanceAPI.getSummary(financialYear);
            if (response.success) {
                return {
                    success: true,
                    data: response.data
                };
            }
            return {
                success: false,
                data: []
            };
        } catch (error) {
            console.error('Error fetching opening balance summary:', error);
            return {
                success: false,
                data: []
            };
        }
    },

    // Get opening balance history
    getHistory: async (params = {}) => {
        try {
            const response = await openingBalanceAPI.getHistory(params);
            if (response.success) {
                return {
                    success: true,
                    data: response.data || []
                };
            }
            return {
                success: false,
                message: response.message || 'Failed to fetch opening balance history',
                data: []
            };
        } catch (error) {
            console.error('Error fetching opening balance history:', error);
            return {
                success: false,
                message: error.message || 'Failed to fetch opening balance history',
                data: []
            };
        }
    },

    // Update opening balance history entry
    updateHistoryEntry: async (id, data) => {
        try {
            const response = await openingBalanceAPI.updateEntry(id, data);
            if (response.success) {
                toast.success(response.message || 'Opening balance updated successfully');
                return response;
            }
            return {
                success: false,
                message: response.message || 'Failed to update opening balance entry'
            };
        } catch (error) {
            console.error('Error updating opening balance entry:', error);
            toast.error(error.message || 'Failed to update opening balance entry');
            return {
                success: false,
                message: error.message || 'Failed to update opening balance entry'
            };
        }
    }
};

export default openingBalanceActions;